/** CPF e RG do visitante (paridade com thalamus-acesso-mobile). */

export function normalizarVisitanteDocumentos(obj) {
  if (!obj || typeof obj !== "object") {
    return { cpf: "", rg: "" };
  }
  const cpf = String(obj.cpf ?? obj.CPF ?? "").trim();
  let rg = String(obj.rg ?? obj.documentoRgCnh ?? obj.documento_rg_cnh ?? "").trim();
  // Legado: só documento_rg_cnh preenchido — exibir como RG se CPF vazio
  if (!cpf && !rg) {
    rg = String(obj.documento_rg_cnh ?? obj.documentoRgCnh ?? "").trim();
  }
  return { cpf, rg };
}

export function visitanteLinhaVaziaDocumentos() {
  return { cpf: "", rg: "", documentoRgCnh: "" };
}

/** Classifica texto digitado em CPF (11 dígitos ou parcial numérico) ou RG. */
export function classificarDocumentoVisitante(valor) {
  const trimmed = String(valor || "").trim();
  if (!trimmed) return { cpf: "", rg: "" };
  const digits = somenteDigitosDocumentos(trimmed);
  const pareceCpf =
    digits.length === 11 ||
    (digits.length > 0 && digits.length < 11 && !/[a-zA-Z]/.test(trimmed));
  if (pareceCpf) return { cpf: trimmed, rg: "" };
  return { cpf: "", rg: trimmed };
}

/** Valor único para input CPF ou RG (exibição). */
export function valorDocumentoUnicoVisitante(v) {
  const { cpf, rg } = normalizarVisitanteDocumentos(v);
  return cpf || rg;
}

/** Atualiza visitante com um único campo documento (mutação in-place). */
export function aplicarDocumentoUnicoVisitante(v, valor) {
  if (!v || typeof v !== "object") return v;
  const { cpf, rg } = classificarDocumentoVisitante(valor);
  v.cpf = cpf;
  v.rg = rg;
  v.documentoRgCnh = rg;
  return v;
}

export function visitanteParaPayloadApi(v) {
  const { cpf, rg } = normalizarVisitanteDocumentos(v);
  return {
    cpf,
    rg,
    documento_rg_cnh: rg,
  };
}

export function somenteDigitosDocumentos(s) {
  return String(s || "").replace(/\D/g, "");
}

export function digitosDocumentosVisitante(v) {
  const { cpf, rg } = normalizarVisitanteDocumentos(v);
  return somenteDigitosDocumentos(cpf) + somenteDigitosDocumentos(rg);
}

export function linhaDocumentosVisitante(v) {
  const { cpf, rg } = normalizarVisitanteDocumentos(v);
  const parts = [];
  if (cpf) parts.push(`CPF: ${cpf}`);
  if (rg) parts.push(`RG: ${rg}`);
  return parts.length ? parts.join(" · ") : "Sem documento";
}

/** Pelo menos um documento (CPF ou RG) preenchido. */
export function temDocumentoVisitante(v) {
  const { cpf, rg } = normalizarVisitanteDocumentos(v);
  return Boolean(cpf || rg);
}
